export default __webpack_public_path__ + "assets/images/69242292709c307dcc9b6e42c68b180a.png";